export default {
  title: 'API keys',
  description:
    'Keys that let a server act for this organization. A key belongs to the organization, not to whoever created it.',
  table: {
    title: 'Keys',
    search: 'Search keys...',
    name: 'Name',
    prefix: 'Prefix',
    permissions: 'Permissions',
    noPermissions: 'None',
    created: 'Created',
    lastUsed: 'Last used',
    expires: 'Expires',
    grantedTo: 'Granted to {name}',
  },
  empty: {
    title: 'No API keys',
    description: 'Create a key to connect a server to this organization.',
  },
  create: {
    button: 'Create a key',
    title: 'Create an API key',
    name: 'Key name',
    namePlaceholder: 'CI deploy',
    nameHint: 'What the key is for, so it can be recognized in the list',
    nameRequired: 'The key needs a name',
    nameTooLong: 'At most {max} characters',
    expiration: 'Expiration',
    expirationHint: 'When should this key stop working?',
    noExpiration: 'No expiration',
    days30: '30 days',
    days60: '60 days',
    days90: '90 days',
    year1: '1 year',
    permissions: 'What the key may do',
    permissionsHint:
      'The key opens the public API for the organization, with these permissions and no other. With none, it opens nothing.',
    submit: 'Create the key',
  },
  created: {
    title: 'Key created',
    description: 'Copy the key now: it is shown this once and cannot be read again.',
    copied: 'Key copied to clipboard',
    copy: 'Copy the key',
    done: 'Done',
  },
  card: {
    prefix: 'Prefix',
    createdBy: 'Created by',
    created: 'Created',
    lastUsed: 'Last used',
    expires: 'Expires',
    never: 'Never',
    neverUsed: 'Never used',
    revoke: 'Revoke',
  },
  revoke: {
    title: 'Revoke this key',
    description: 'Anything using "{name}" stops authenticating at once. This cannot be undone.',
    confirm: 'Revoke the key',
    revoked: 'Key revoked',
    failed: 'The key could not be revoked. Try again.',
  },
  errors: {
    invalid: 'This key cannot be created: check its name and its expiry.',
    forbidden: 'You may not create API keys in this organization.',
    createFailed: 'The key could not be created. Try again.',
  },
}
